import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { conferencesManager, type IConference } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const CONFERENCE_MODULE = 'conference';

const searchModule = getSearchModule<IConference>(conferencesManager);
const dataObjectModule = getDataObjectsModule<IConference>(conferencesManager);

const conferenceModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(CONFERENCE_MODULE, conferenceModuleInstance);

export { CONFERENCE_MODULE };
